import Footer from '../Footer'
import Header from '../Header'
import './global.css'
import * as style from './style.module.scss'
import * as React from 'react'

function Template({ fullWidth = false, dashboardLayout = false, ...props }) {
  return (
    <>
      {process.env.GATSBY_SITE === 'doggos' && (
        <>
          {dashboardLayout ? (
            <div className={style.dashboardShell}>{props.children}</div>
          ) : (
            <>
              <Header />
              <div className={style.body}>
                <div
                  className={`${style.container} ${
                    fullWidth ? style.fullWidth : ''
                  }`}
                >
                  <div className={style.content}>{props.children}</div>
                </div>
              </div>
              <Footer />
            </>
          )}
        </>
      )}
    </>
  )
}

export default Template
